module.exports = "/_next/static/images/HeroIndustryStartups@3x-1177dff42945951a959339a1145101c0.webp";